import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading" width="100%" theme="light" alignment="yes" paddingTop="5" paddingBottom='5' className="pricing-title-right py-0 text-align-left div-p-0 left-content pricing-h2" mdxType="TextBlock" />
    <h3 {...{
      "id": "paid-plans"
    }}>{`Paid Plans`}</h3>
    <TextBlock slots="text" width="100%" theme="light" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 list-points div-p-0 left-content" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Volume and multi-product discounts`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Access to all 15+ PDF Services, including PDF Extract, PDF Accessibility Auto-Tag API, Adobe PDF Electronic Seal API, and Document Generation`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Scalable for high volume needs`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Technical Support available on certain plans`}</p>
      </li>
    </ul>
    <TextBlock slots="buttons" width="100%" theme="light" alignment="yes" paddingTop="5" paddingBottom='5' className="pb-1 left-Contact div-p-0 left-content" mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./contact/sales/"
        }}>{`Contact sales`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      